import apiFetch from "../../../../shared/services/apiClient";

/**
 * Envía el correo de una o varias facturas.
 * @param {number[]} facturaIds - array de id_factura
 * @returns {{ enviados, errores, total_enviados, total_errores }}
 */
export async function sendInvoiceEmail(facturaIds) {
  const res = await apiFetch("/api/finance/factura/enviar-email/", {
    method: "POST",
    body: JSON.stringify({ factura_ids: facturaIds }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? "Error al enviar el correo.");
  }

  return res.json();
}
